import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  CircularProgress,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import CollectsBuysStaticsTeamRow from './CollectsBuysStaticsTeamRow';

const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
    },
  },
});

const CollectsBuysStaticsTeamTable = ({
  loading,
  data,
  tableRef,
  headerRows,
  selectedGbn,
}) => {
  const classes = useStyles();
  //   if (loading || !data) {
  //     return (
  //       <Box sx={{ display: 'flex' }}>
  //         <CircularProgress />
  //       </Box>
  //     );
  //   }

  return (
    <Paper sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table size="small" className={classes.table} ref={tableRef}>
          <TableHead>
            <TableRow>
              <TableCell align="center" rowSpan={2}>
                본부
              </TableCell>
              <TableCell align="center" rowSpan={2}>
                팀
              </TableCell>
              <TableCell align="center" colSpan={headerRows?.length}>
                {selectedGbn === 'sales' ? '수금 금액' : '지급 금액'}
              </TableCell>
            </TableRow>
            <TableRow>
              {headerRows &&
                headerRows.map((header, index) => {
                  return (
                    <TableCell key={index} align="center">
                      {header !== 'total' ? `${header}월` : `합계`}
                    </TableCell>
                  );
                })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data === null || data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={headerRows?.length + 1} align="center">
                  데이터가 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              <CollectsBuysStaticsTeamRow data={data} headers={headerRows} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default CollectsBuysStaticsTeamTable;
